import React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbTableTHead as ClbTableTHead_ } from '@celebration/design-system/dist/lib/table-thead';
export const ClbTableTHead = createComponent({
    tagName: ClbTableTHead_.tagName,
    elementClass: ClbTableTHead_,
    react: React,
    events: {},
});
//# sourceMappingURL=index.js.map